module.exports = __webpack_public_path__ + "media/img/help_center/Institution_User_Settings_03-eaf88c10b39bb51ef77fd1cb575c089c.jpg";